import { useDispatch } from 'react-redux';
import { push } from 'redux-first-history';

import BasicModal from '@app/components/Modal/BasicModal';
import { ParticipantPageLocationStateOnSigningRightNow } from '@app/routes/Participant';
import { modalClose } from '@app/store/modal/actions';

interface DocumentsDirectToContractProps {
  content: string;
  confirmText: string;
  documentId: string;
}

function DocumentsDirectToContract({
  content,
  confirmText,
  documentId,
}: DocumentsDirectToContractProps) {
  const dispatch = useDispatch();

  const handleCancel = () => {
    dispatch(modalClose());
  };

  const handleClose = () => {
    dispatch(
      push<ParticipantPageLocationStateOnSigningRightNow>('/participant', {
        documentId,
        isSigningRightNow: true,
      })
    );
    dispatch(modalClose());
  };

  return (
    <BasicModal
      cancelText="취소"
      closeText={confirmText}
      content={content}
      title="서명 요청 완료"
      onCancel={handleCancel}
      onClose={handleClose}
    />
  );
}

export default DocumentsDirectToContract;
